import { makeStyles, Theme } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core';

interface BaseProps {
  error?: boolean;
  helperText?: string;
  id: string;
  onChange: (value: string) => void;
  type: string;
  value: string | number | boolean | string[];
}

const useStyles = makeStyles((theme: Theme) => ({
  input: {
    width: '100%',
  },
}));

const Base = ({ error, helperText, id, onChange, type, value }: BaseProps) => {
  const classes = useStyles();
  return (
    <TextField
      className={classes.input}
      error={error}
      helperText={helperText}
      id={id}
      InputLabelProps={{
        shrink: true,
      }}
      onChange={(e) => onChange(e.target.value)}
      type={type}
      value={value}
    />
  );
};
export default Base;
